import BeSimpleAPI from '@/providers/api/';

import { baseActions } from './../base_actions'
import { baseMutations } from './../base_mutations'

const state =
{
    api: new BeSimpleAPI(process.env.VUE_APP_CORE_API_URL),
    'administrations': {
        items: [],
        item: {}
    },
    'users': {
        items: [],
        item: {}
    },
    'contact-persons': {
        items: [],
        item: {},
        path: function(params) {
            return `/customer-relations/${params.customerRelationId}/contact-persons`;
        }
    },
    'customer-relations': {
        items: [],
        item: {}
    },
    'groups': {
        items: [],
        item: {}
    },
    'permissions': {
        items: [],
        item: {},
    },
    'modules': {
        items: [],
        item: {},
    }
}

const getters = {
    //List getters
    administrations: state => state['administrations'].items,
    users: state => state['users'].items,
    
    contactPersons: state => state['contact-persons'].items,
    customerRelations: state => state['customer-relations'].items,

    groups: state => state['groups'].items,
    permissions: state => state['permissions'].items,

    modules: state => state['modules'].items,
    
    //Single getters
    administration: state=> state['administrations'].item,
    user: state=> state['users'].item,

    contactPerson: state=> state['contact-persons'].item,
    customerRelation: state => state['customer-relations'].item,

    group: state => state['groups'].item,
    permission: state => state['permissions'].item,
    
    module: state => state['modules'].item,
}

const actions = {
    ...baseActions
}

const mutations = {
    ...baseMutations
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}